export enum PaymentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED'
}

export enum PaymentMethod {
  STRIPE = 'STRIPE',
  RAMBURS = 'RAMBURS'
}

export interface Payment {
  id: number;
  orderId: number;
  amount: number;
  method: PaymentMethod;
  status: PaymentStatus;
  stripePaymentId?: string;
  createdAt: string;
  updatedAt: string;
  order: {
    id: number;
    user: {
      name: string;
      email: string;
    };
  };
}

export interface PaymentsResponse {
  payments: Payment[];
  total: number;
  page: number;
  pageSize: number;
}
